export default interface User { 
  email: string;
  firstName: string;
  forwarder_id: number;
  lastName: string;
  terms_and_conditions_agreed: boolean;
  org: string;
  orgAddress: string;
  role: string;
  roleId: number;
  roleName: string;
  tel: string;
  gha_id?: number;
  custom_password?: boolean;
  verified?: boolean;
  userId?: number;
  stations?: string;
  gha?: string;
};

export interface GhaUser {
  email: string;
  firstName: string;
  forwarder_id: number;
  lastName: string;
  terms_and_conditions_agreed: boolean;
  org: string;
  orgAddress: string;
  role: string;
  roleId: number;
  roleName: string;
  tel: string;
  gha_id?: number;
  custom_password?: boolean;
  userId: number;
  group: string;
  sideBar: Array<string>;
};

export enum UserRoleType {
  FORWARDER = 'fwd',
  GHA = 'gha',
  INCOGNITO = 'incognito'
};

export enum UserRoleId {
  ADMIN = 1,
  FORWARDER_ADMIN = 2,
  FORWARDER_USER = 3,
  GHA_ADMIN = 4,
  GHA_OFFICE = 5,
  GHA_WAREHOUSE = 6,
  GHA_SUPERVISOR = 7,
  GHA_MANAGER = 8,
  GHA_ACCOUNTING = 9,
  GHA_SCREENER = 10,
  GHA_WH_SCREENER = 11,
  GHA_DASHBOARD = 12,
  GHA_AIR_REPRESENTATIVE = 13,
  GHA_OFFLINE_RFS_REP = 14,
  GHA_SUPERVISOR_WAREHOUSE = 15,
  GHA_MANAGER_WAREHOUSE = 16,
  GHA_SUPER_USER = 17,
  LAX_OFFICE_AGENT = 18,
  GHA_ACC_RECO = 19
};
